import { Select } from "antd";
import styles from "./Home.module.css";

const { Option } = Select;

interface ModuleReportContentProps {
  title: string;
}

const ModuleReportContent = ({ title }: ModuleReportContentProps) => (
  <>
    <div className={styles.homeHeader}>
      <div className={styles.updateInfo}>Fonts actualitzades el 00/00/0000</div>
      <h1 className={styles.mainTitle}>{title}</h1>
    </div>
    <div className={styles.homeContainer}>
      <div className={styles.aiSummary}>
        <h2 className={styles.aiSummaryTitle}>Resumen IA</h2>
        <div className={styles.aiSummaryContent}>
          <ul className={styles.aiSummaryList}>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</li>
            <li>Ut enim ad minim veniam, quis nostrud exercitation ullamco.</li>
            <li>Duis aute irure dolor in reprehenderit in voluptate velit esse.</li>
          </ul>
        </div>
      </div>
      <div className={styles.newContainer}>
        <div className={styles.graphHeader}>
          <h2 className={styles.graphTitle}>Graph tit</h2>
          <Select
            className={styles.filterSelect}
            placeholder="filtre"
            defaultValue="filtre"
          >
            <Option value="filtre">filtre</Option>
          </Select>
        </div>
        <div className={styles.graphContent}>
          <p className={styles.pendingMessage}>Pendiente de definición funcional</p>
        </div>
      </div>
    </div>
  </>
);

export default ModuleReportContent;
